import { render, staticRenderFns } from "./ed-register-agreement.component.vue?vue&type=template&id=5dd592a5&scoped=true&"
import script from "./ed-register-agreement.component.ts?vue&type=script&lang=ts&"
export * from "./ed-register-agreement.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-register-agreement.component.scss?vue&type=style&index=0&id=5dd592a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd592a5",
  null
  
)

export default component.exports